import { Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

import { SignIn } from "./Pages/SignInAdmin";
import { MainCategoriesPage } from "./Pages/MainCategoriesPage";
import { CategoryDashboard } from "./Pages/Knowledge Center/CategoryDashboard";
import { CommunityForumDashboard } from "./Pages/Community Forum/CommunityForumDashboard";
import { ModernChat } from "./Pages/Community Forum/ModernChat";
import ChangePassword from "./Pages/Account/ChangePassword";

import Logout from "./Pages/Account/Logout";
import { AddEntry } from "./Pages/Knowledge Center/AddEntry";
import { EntryDetails } from "./Pages/Knowledge Center/EntryDetails";

function App() {
  return (
    <div className="App">

      <Routes>
        <Route path="/" element={<SignIn />} />
        <Route path="/admin/signin" element={<SignIn />} />
        <Route path="/admin/dashboard" element={<MainCategoriesPage />} />
        <Route path="/admin/category/:mainCategoryId" element={<CategoryDashboard />} />
        <Route path="/admin/community-forum/:mainCategoryId" element={<CommunityForumDashboard />} />
        <Route path="/admin/community-forum/chat" element={<ModernChat />} />

        <Route
          path="/admin/topic-entries/:mainCategoryId/:subCategoryId/:topicId/create"
          element={<AddEntry />}
        />
        <Route
          path="/admin/topic-entries/:mainCategoryId/:subCategoryId/:topicId/edit/:entryId"
          element={<AddEntry />}
        />
        <Route
          path="/admin/topic-entries/:mainCategoryId/:subCategoryId/:topicId/preview/:entryId"
          element={<EntryDetails />}
        />
        <Route
          path="/admin/topic-entries/:mainCategoryId/:subCategoryId/:topicId/view/:entryId"
          element={<EntryDetails />}
        />

        <Route path="/admin/password" element={<ChangePassword />} />
        <Route path="/admin/logout" element={<Logout />} />

      </Routes>
    </div>
  );
}

export default App;
